// Brand Assets Configuration
export const BRAND_ASSETS = {
  logo: "https://static.lumi.new/material/8c/8cc6d6e3e90f2bd9cc6236466acb6100.png", // Main logo
  logoStatic: "https://static.lumi.new/material/8c/8cc6d6e3e90f2bd9cc6236466acb6100.png", // Static PNG fallback
  logoAlt: "https://static.lumi.new/material/8c/8cc6d6e3e90f2bd9cc6236466acb6100.png", // Alternative PNG
  logoVideo: "https://cdn-static-lumi.artvibe.ai/01/01d69e8806dba9c3fae014d4bbaba5ea.mp4", // Video logo option
  brandName: "Zoefel IA",
  // Add other brand assets here as needed
  // favicon: "...",
  // ogImage: "...",
  // etc.
};
